<template>
  <v-dialog v-model="dialog" max-width="640px">
    <v-card>
      <div>
        <v-card-title>
          <p class="headline mb-1" style="width: 100%">
            {{ mess.dialog_create_lead_title }}
          </p>
          <b
            v-if="currentLead"
            style="font-size: 14px; line-height: 1"
            :style="{ color: siteColors.primary }"
            class="mb-0"
          >
            {{ currentLead.companyName }}
          </b>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row
              v-if="
                (Array.isArray(currentLead.ps) && currentLead.ps.length > 1) ||
                  (!(
                    userType.sm ||
                    userType.vimelco ||
                    userType.partner ||
                    userType.ersaProses ||
                    userType.endUser
                  ) &&
                    Array.isArray(currentLead.ps) &&
                    currentLead.ps.length === 1 &&
                    currentLead.ps[0].id)
              "
              class="mb-4"
            >
              <v-col cols="12" class="pa-1"
                ><b>{{ mess.dialog_create_lead_select_ps }}</b></v-col
              >
              <v-col
                cols="12"
                class="pa-1"
                style="height: 180px; overflow-y: scroll; border: 1px solid #9c9c9c; border-radius: 6px"
              >
                <v-checkbox
                  v-for="ps in currentLead.ps"
                  :key="ps.id"
                  @change="psCheckHandler"
                  v-model="formLead.ps"
                  :label="ps.name"
                  color="primary"
                  :value="ps.id"
                  hide-details
                  class="create-lead-checkbox ma-0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-1"
                ><b>{{ mess.dialog_create_lead_select_eq }}</b></v-col
              >
              <v-col
                cols="12"
                class="pa-1"
                style="height: 180px; overflow-y: scroll; border: 1px solid #9c9c9c; border-radius: 6px"
              >
                <v-checkbox
                  v-for="eq in filteredIB"
                  :key="eq.id"
                  @change="checkCp"
                  v-model="formLead.eq"
                  :label="eq.name"
                  color="primary"
                  :value="eq.id"
                  hide-details
                  class="create-lead-checkbox ma-0"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex flex-column" style="padding: 0 16px 16px">
          <b
            style="font-size: 14px; line-height: 1;"
            class="align-self-start mb-3"
            >{{ mess.dialog_create_lead_buttons_title }}</b
          >
          <v-text-field
            v-model="query"
            @keyup.enter="createLeadArticlesSearchDialog = true"
            outlined
            dense
            hide-details
            :label="mess['search_label']"
            style="width: 100%"
            class="articles-search mb-3"
          >
            <template v-slot:append>
              <v-btn depressed color="#e4e4e4" height="26" class="mr-1">
                <v-icon size="18" color="#999">mdi-file</v-icon>
                <span
                  class="text-truncate"
                  style="max-width: 120px; font-size: 12px; font-weight: 400; text-transform: none; color: #999; letter-spacing: 0"
                  >{{ file ? file.name : mess["load_file"] }}</span
                >
                <v-file-input
                  v-model="file"
                  class="articles-file-input"
                  style="width: 100%; position: absolute; cursor: pointer; opacity: 0; padding: 0;
  height: 30px;
  margin: 0;"
                  hide-details
                ></v-file-input>
              </v-btn>
              <v-btn
                @click="createLeadArticlesSearchDialog = true"
                depressed
                color="primary"
                min-width="26"
                width="26"
                height="26"
              >
                <v-icon size="20" color="white">search</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-btn
            @click.prevent="getArticles('by_rpl')"
            :disabled="!formLead.ps.length || !formLead.eq.length"
            style="width: 100%; font-size: 14px; letter-spacing: 0; text-transform: unset"
            class="mb-3 ml-0"
            outlined
            color="primary"
            depressed
            >{{ mess.dialog_create_lead_button_by_rpl }}
          </v-btn>
          <v-btn
            @click.prevent="
              getArticles(
                userType.sm ||
                  userType.vimelco ||
                  userType.partner ||
                  userType.ersaProses ||
                  userType.endUser
                  ? 'by_cp'
                  : 'by_cp_ps'
              )
            "
            :disabled="
              !formLead.ps.length || !formLead.eq.length || !formLead.hasCp
            "
            style="width: 100%; font-size: 14px; letter-spacing: 0; text-transform: unset"
            class="mb-3 ml-0"
            outlined
            color="primary"
            depressed
            >{{ mess.dialog_create_lead_button_by_cp }}</v-btn
          >
          <v-btn
            @click.prevent="getArticles('by_equipments')"
            :disabled="!formLead.ps.length || !formLead.eq.length"
            style="width: 100%; font-size: 14px; letter-spacing: 0; text-transform: unset"
            class="mb-3 ml-0"
            outlined
            color="primary"
            depressed
            >{{ mess.dialog_create_lead_button_by_all }}</v-btn
          >
          <v-btn
            @click.prevent="getArticles('by_cp_ps_and_eqs')"
            :disabled="
              !formLead.ps.length || !formLead.eq.length || !formLead.hasCp
            "
            style="width: 100%; font-size: 14px; letter-spacing: 0; text-transform: unset"
            class="mb-3 ml-0"
            outlined
            color="primary"
            depressed
            >{{ mess.dialog_create_lead_button_by_cp_ps_and_eqs }}</v-btn
          >
          <v-btn
            style="width: 100%; font-size: 14px; letter-spacing: 0; text-transform: unset"
            class="mb-3 ml-0"
            outlined
            color="primary"
            depressed
            dark
            @click="dialog = false"
            >{{ mess.dialog_base_button_close }}</v-btn
          >
        </v-card-actions>
        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <create-lead-articles-dialog
        :is-visible.sync="createLeadArticlesDialog"
        :orders="articles"
        :export-fields="exportFields"
        :article-headers="articleHeaders"
        :company="currentLead.companyName"
        :market-area-filters="marketAreaFilters"
        @added-to-cart="createLeadSuccessDialog = true"
        @added-to-cart-single-item="$emit('added-to-cart-single-item', $event)"
        @error="$emit('error', $event)"
      ></create-lead-articles-dialog>

      <create-lead-articles-search-dialog
        :is-visible.sync="createLeadArticlesSearchDialog"
        :export-fields="exportFields"
        :article-headers="articleHeaders"
        :search-query.sync="query"
        :search-file.sync="file"
        :company="currentLead.companyName"
        :market-area-filters="marketAreaFilters"
        @added-to-cart="createLeadSuccessDialog = true"
        @added-to-cart-single-item="$emit('added-to-cart-single-item', $event)"
        @error="$emit('error', $event)"
      >
      </create-lead-articles-search-dialog>

      <create-lead-success-dialog :is-visible.sync="createLeadSuccessDialog">
      </create-lead-success-dialog>

      <v-overlay :value="overlay" absolute color="white" opacity="1">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
// Libs
import axios from "axios";

// Components
import CreateLeadArticlesDialog from "@/components/dialogs/CreateLeadArticlesDialog";
import CreateLeadArticlesSearchDialog from "@/components/dialogs/CreateLeadArticlesSearchDialog";
import CreateLeadSuccessDialog from "@/components/dialogs/CreateLeadSuccessDialog";

// Models
import notifications from "@/models/notificationTemplates";

export default {
  name: "CreateLeadDialog",
  components: {
    CreateLeadSuccessDialog,
    CreateLeadArticlesSearchDialog,
    CreateLeadArticlesDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    companyForLead: {
      type: Object,
      default: () => {}
    },
    articleHeaders: {
      type: Array,
      default: () => []
    },
    marketAreaFilters: {
      type: [Array, null],
      default: () => null
    }
  },
  data() {
    return {
      dialog: false,
      overlay: true,
      createLeadArticlesDialog: false,
      createLeadArticlesSearchDialog: false,
      createLeadSuccessDialog: false,
      currentLead: {
        companyId: "",
        companyName: "",
        ps: "",
        eq: ""
      },
      formLead: {
        companyId: "",
        ps: [],
        eq: [],
        hasCp: false
      },
      modalLeadTableStatus: false,
      dealArticles: [],
      exportFields: [],
      selectedArticles: [],
      articles: [],
      query: undefined,
      file: null,
      acceptFile: true
    };
  },
  methods: {
    setCompanyForLead(lead) {
      this.currentLead = lead;
      this.modalLeadTableStatus = false;
      this.selectedArticles = [];
      this.formLead = {
        companyId: this.currentLead.companyId,
        hasCp: false,
        ps: this.currentLead.ps.length === 1 ? [this.currentLead.ps[0].id] : [],
        eq: []
      };
    },
    getArticles(type) {
      if (this.formLead.ps.length && this.formLead.eq.length) {
        this.createLeadArticlesDialog = true;
        let formData = new FormData();
        formData.append("type", type);
        formData.append("ps", this.formLead.ps);
        formData.append("eq", this.formLead.eq);
        formData.append("company_id", this.formLead.companyId);

        axios
          .post(
            "/local/ajax/route/catalog/find_articules_old/?page=company_list",
            formData
          )
          .then(response => {
            if (response.data.success) {
              this.articles = response.data.articles;
            } else {
              this.$emit("error", notifications.error.base);
              this.createLeadArticlesDialog = false;
            }
          })
          .catch(() => {
            this.$emit("error", notifications.error.base);
            this.createLeadArticlesDialog = false;
          });
      }
    },
    checkCp() {
      if (this.formLead.eq && this.formLead.eq.length) {
        let formData = new FormData();
        formData.append("company_id", this.formLead.companyId);
        formData.append("ps", this.formLead.ps);
        formData.append("eq", this.formLead.eq);

        axios
          .post("/local/ajax/crm/isHasConsumptionPlan.php", formData)
          .then(response => {
            this.formLead.hasCp = response.data.cp;
          })
          .catch(() => {});
      }
    },
    removeIb() {
      // текущие выбранные PS
      let selectedPs = [];
      this.currentLead.ps.forEach(ps => {
        this.formLead.ps.forEach(selectedPsId => {
          if (ps.id === selectedPsId) selectedPs.push(ps);
        });
      });

      // все IB, входящие в выбранные PS
      let selectedIb = [];
      selectedPs.forEach(ps => (selectedIb = [...selectedIb, ...ps.eq]));
      let selectedIbIds = selectedIb.map(eq => eq.id);

      // результирующая выборка id для IB
      const resultIbIds = [];
      this.formLead.eq.forEach(ibId => {
        if (selectedIbIds.some(id => id === ibId)) resultIbIds.push(ibId);
      });

      this.formLead.eq = resultIbIds;
    },
    psCheckHandler() {
      this.removeIb();
      this.checkCp();
    }
  },
  computed: {
    filteredIB() {
      const psArr = this.currentLead.ps;
      let ibArr = [];
      for (let ps of psArr) {
        for (let psCurrentID of this.formLead.ps) {
          if (ps.id === psCurrentID) {
            for (let i = 0; i < ps.eq.length; i++) {
              if (!ibArr.some(eq => eq.id === ps.eq[i].id))
                ibArr.push(ps.eq[i]);
            }
          }
        }
      }
      return ibArr;
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
      !!val || (this.overlay = true);
    },
    companyForLead(val) {
      this.setCompanyForLead(val);
      this.overlay = false;
    },
    createLeadArticlesDialog(val) {
      !!val || (this.articles = []);
    },
    file(val) {
      !val || (this.createLeadArticlesSearchDialog = true);
    }
  }
};
</script>

<style lang="scss">
.create-lead-checkbox {
  label {
    height: auto !important;
    font-size: 14px !important;
    line-height: 1.2 !important;
    font-weight: 500 !important;
    color: #1a1a1a !important;
  }
}

.articles-file-input .v-input__append-inner {
  display: none;
}

.articles-search {
  .v-input__append-inner {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
}
</style>
